// Bulk group management from the signals list: assign N keys to a group
// (mode: 'assign') or remove their explicit assignments so they revert to
// automatic grouping (mode: 'unassign').
const action = "SIGNAL_GROUP_ASSIGN";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const CLEAR = action + '_CLEAR';
export const FAILURE = action + '_FAILURE';

// payload: { mode: 'assign' | 'unassign', keys: [...], group?: 'name' }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const clearState = () => ({ type: CLEAR });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
